import axios from 'axios';
import { apiUri } from './config';

const requestWithRefresh = async (request: () => Promise<any>) => {
  let accessToken = localStorage.getItem('accessToken');
  let refreshToken = localStorage.getItem('refreshToken');
  let response;
  try {
    response = await request();
  } catch (error: any) {
    const { response } = error;
    if (response?.status === 401 && refreshToken) {
      // Access token expired, try to refresh
      const refreshResponse = await axios.post(`${apiUri}/token/refresh`, {
        token: refreshToken,
      });

      if (refreshResponse.status === 200) {
        // Successfully refreshed, save new access token and retry request
        accessToken = refreshResponse.data.accessToken;
        localStorage.setItem('accessToken', accessToken);
        return request();
      } else {
        // Refresh failed, clear tokens and redirect to auth
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('admin');
        window.location.href = '/auth';
      }
    } else if (response.status === 401) {
      // No refresh token available, clear tokens and redirect to auth
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('admin');
      window.location.href = '/auth';
    } else {
      alert(response.data.error);
    }
  }

  return response;
};

export const getApi = async (url: string): Promise<any> => {
  try {
    return await requestWithRefresh(() =>
      axios.get(`${apiUri}/${url}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }),
    );
  } catch (error) {
    console.error(error);
    //throw error;
  }
};

export const postApi = async (url: string, data: any): Promise<any> => {
  try {
    return await requestWithRefresh(() =>
      axios.post(`${apiUri}/${url}`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }),
    );
  } catch (error) {
    console.error(error);
    //throw error;
  }
};

export const patchApi = async (url: string, data: any): Promise<any> => {
  try {
    return await requestWithRefresh(() =>
      axios.patch(`${apiUri}/${url}`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }),
    );
  } catch (error) {
    console.error(error);
    //throw error;
  }
};

export const deleteApi = async (url: string): Promise<any> => {
  try {
    return await requestWithRefresh(() =>
      axios.delete(`${apiUri}/${url}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }),
    );
  } catch (error) {
    console.error(error);
    //throw error;
  }
};

export const encodeFilters = (filters: { [key: string]: string }) => {
  let url = '';
  Object.keys(filters).forEach((key) => {
    if (filters[key]) {
      url += `&${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`;
    }
  });
  return url;
};

export function debounce(fn: any, delay: number): (...args: any) => void {
  let timeoutID: NodeJS.Timeout | null;
  return (...args: any): void => {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
    timeoutID = setTimeout(() => fn(...args), delay);
  };
}
